import React from 'react';

import Wrapper from './styles';

const LayoutContainer = props => <Wrapper {...props} />;

export default LayoutContainer;
